import { IInterface, IInterfaceDTD } from 'utility-js-interface';

export class ChoiceBuilderDTO {
  static _Interface: IInterface;
  static _ChoiceBuilderDTD: IInterfaceDTD;
  constructor(data: any) {
    ChoiceBuilderDTO._Interface.gateway(ChoiceBuilderDTO._ChoiceBuilderDTD, data, this);
  }
}

angular
  .module('capability-ng-poll')
  .constant('ChoiceBuilderDTD', {
    id: 'key',
    nk: 'string',
    text: 'string'
  })
  .factory('ChoiceBuilder', (Interface: IInterface, ChoiceBuilderDTD: IInterfaceDTD): any => {
    ChoiceBuilderDTO._Interface = Interface;
    ChoiceBuilderDTO._ChoiceBuilderDTD = ChoiceBuilderDTD;
    return ChoiceBuilderDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/builders/choice_builder.ts